import * as React from "react";
import { Icon } from "sb-resp-ui";
import { StakeModifier } from "../../../../data/models";

const baseClass = "rj-my-pulse-bets__stake-btn";

//export enum Props { plus = "plus", minus = "minus" }
export class StakeButton extends React.Component<{
    isActive: boolean
    modifier: StakeModifier
    handler: (MouseEvent) => void
}, {}> {

    render() {
        const { isActive, modifier, handler } = this.props;
        const mdf = ` ${baseClass}--${modifier}`;
        return (
            <button disabled={isActive}
                    className={`${baseClass}${mdf}`}
                    onClick={handler}>
                <Icon i={`i-14 i-o-pulse-${modifier}`}/>
            </button>
        )
    }
}